import { render, staticRenderFns } from "./addCommodity.vue?vue&type=template&id=5389a868&scoped=true"
import script from "./addCommodity.vue?vue&type=script&lang=js"
export * from "./addCommodity.vue?vue&type=script&lang=js"
import style0 from "./addCommodity.vue?vue&type=style&index=0&id=5389a868&prod&scoped=true&lang=css"
import style1 from "./addCommodity.vue?vue&type=style&index=1&id=5389a868&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5389a868",
  null
  
)

export default component.exports